import { render, staticRenderFns } from "./customItem.vue?vue&type=template&id=a44d11b6&scoped=true&"
import script from "./customItem.vue?vue&type=script&lang=js&"
export * from "./customItem.vue?vue&type=script&lang=js&"
import style0 from "./customItem.vue?vue&type=style&index=0&id=a44d11b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44d11b6",
  null
  
)

export default component.exports